/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCustomFscIndex.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/custom-fsc-index";

export class AutogenModelCustomFscIndex<RowType extends ModelRow> extends Endpoint<RowType, RowCustomFscIndexFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCustomFscIndex extends ModelRow<RowCustomFscIndexFields> {
	constructor(values?: Partial<RowCustomFscIndexFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCustomFscIndexFields {
	company_id: string;
	descr: string;
	id: string;
	region_10_description: string;
	region_11_description: string;
	region_12_description: string;
	region_13_description: string;
	region_14_description: string;
	region_15_description: string;
	region_16_description: string;
	region_1_description: string;
	region_2_description: string;
	region_3_description: string;
	region_4_description: string;
	region_5_description: string;
	region_6_description: string;
	region_7_description: string;
	region_8_description: string;
	region_9_description: string;
}

